import { Team } from '../models';
import { TeamRepository } from '../repositories';

export class GetTeamByIdUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(teamId: string): Promise<Team | null> {
    return this.teamRepository.getById(teamId);
  }
}
